<template>
  <div class="lc-main-window">
    <div
      class="lc-main-window__no-selected"
      v-if="!loading && !selectedUser"
    >{{ $t('view.livechat.noSelected') }}</div>
    <livechat-chat
      class="lc-main-window__chat-window"
      v-if="!loading && selectedUser"
      :personas="personas"
      v-model="selectedUser"
      :socket="socket"
    ></livechat-chat>
    <livechat-users
      class="lc-main-window__users-list"
      v-if="!loading"
      :users="getUsersToDisplay()"
      :tags="tags"
      :usersGroups="usersGroups"
      :selectedUser="selectedUser"
      @selected="userSelected"
      :socket="socket"
    ></livechat-users>
    <!-- <div class="lc-main-window__no-users" v-if="noUsers">
      <div class="lc-main-window__no-users-text">{{ $t('view.livechat.noUsers') }}</div>
    </div> -->
    <div class="lc-main-window__loading" v-if="loading">
      <logo-loader ref="loader" color="dark"></logo-loader>
      <!-- <div class="lc-main-window__loading-cont">
        <div class="lc-main-window__loading-text">{{ $t('view.livechat.loading') }}</div>
        <fai class="lc-main-window__loading-spinner lc-main-window__spinner-anim" icon="spinner"/>
      </div>-->
    </div>
  </div>
</template>

<script>
import io from 'socket.io-client'
import store from '@/store'
import axios from '@/axios'

export default {
  data() {
    return {
      socket: null,
      users: [],
      personas: [],
      tags: [],
      tagsConnections: [],
      selectedUser: null,
      loading: true,

      usersGroups: [
        {
          name: this.$t('view.livechat.userGroups.moderator'),
          filter: (item) => { if (item.userData.moderator_chat) return true },
          comp: (item1, item2) => {
            if ((item1.userData.moderator_chat_order === null && item2.userData.moderator_chat_order === null) || item1.userData.moderator_chat_order === item2.userData.moderator_chat_order) {
              return 0
            }
            if (item1.userData.moderator_chat_order === null) { // item2 is number
              return -1
            }
            if (item2.userData.moderator_chat_order === null) { // item1 is number
              return 1
            }
            if (item1.userData.moderator_chat_order > item2.userData.moderator_chat_order) {
              return -1
            }
            return 1
          },
          offset: 0,
          receivedAction: false,
          loading: false,
          toggled: true,
          dbParam: 'mod',
          pagingIter: 0,
          count: 0,
          pageLimit: 250
        },
        {
          name: this.$t('view.livechat.userGroups.other'),
          filter: (item) => { if(!item.userData.moderator_chat) return true },
          comp: (item1, item2) => {
            let sent_at1 = null
            let sent_at2 = null 
            if(item1.userData.last_msg_date) sent_at1 = new Date(item1.userData.last_msg_date)
            if(item2.userData.last_msg_date) sent_at2 = new Date(item2.userData.last_msg_date)
            if(sent_at1 === null && item1.msgs && item1.msgs.length) sent_at1 = new Date(item1.msgs[item1.msgs.length - 1].sent_at)
            if(sent_at2 === null && item2.msgs && item2.msgs.length) sent_at2 = new Date(item2.msgs[item2.msgs.length - 1].sent_at)
            if(sent_at1 === null && sent_at2 === null) {
              return 0
            }
            if(sent_at1 === null) {
              return 1
            }
            if(sent_at2 === null) {
              return -1
            }
            if(sent_at1 <= sent_at2) {
              return 1
            }
            return -1
          },
          offset: 0,
          loading: false,
          receivedAction: false,
          toggled: true,
          dbParam: 'noMod',
          pagingIter: 0,
          count: 0,
          pageLimit: 250
        }
      ]
    }
  },

  created () {
    this.fetchPersonas()
    this.fetchTags()
    this.fetchTagsConnections()
    this.connectSocket()
  },

  beforeDestroy() {
    if (this.socket) {
      this.socket.emit('disconnected')
      this.socket.removeAllListeners()
    }
  },

  methods: {
    connectSocket() {
      this.socket = io()
      this.attachEvents()
      this.socket.on('connect', () => {
        this.onConnect()
      })
    },

    async attachEvents () {
      this.socket.on('users', async (users, param) => {
        this.onReceiveUsers(users)
        this.fillUsersWithTags(users)
        if(this.loading) {
          this.loading = false
          //this.startSelected()
        }
        for (let i = 0; i < this.usersGroups.length; i++) {
          if (this.usersGroups[i].dbParam === param) this.usersGroups[i].receivedAction = true
        }
      })
      this.socket.on('usersHistories', (histories) => {
        for(let i = 0; i<histories.length; i++) {
          for(let j = 0; j<this.users.length; j++) {
            if(histories[i].userId === this.users[j].userData.id) {
              if(histories[i].msgs) this.users[j].msgs = histories[i].msgs
            }
          }
        }
      })
      this.socket.on('message', (userId, msg) => {
        this.onReceiveMsg(userId, msg)
      })
      this.socket.on('userResolved', userId => {
        this.onReceiveUserResolved(userId)
      })
      this.socket.on('userControlled', (userId, order) => {
        for (let i = 0; i < this.users.length; i++) {
          if (this.users[i].userData.outside_id === userId) {
            const spliced = this.users.splice(i, 1)[0]
            this.adjustOffsetBefore(spliced)
            spliced.userData.moderator_chat = true
            spliced.userData.moderator_chat_order = order
            this.adjustOffsetAfter(spliced)
            this.users.push(spliced)
          }
        }
      })
      this.socket.on('userRequest', user => {
        for (let i = 0; i < this.users.length; i++) {
          if (this.users[i].userData.outside_id === user.userData.outside_id) {
            this.adjustOffsetBefore(this.users[i])
            this.users[i].userData.moderator_chat = true
            this.users[i].userData.moderator_chat_order = user.userData.moderator_chat_order
            this.adjustOffsetAfter(this.users[i])
            return
          }
        }
        user.liveData = {
          new: true,
          tags: [],
          loadFailed: false
        }
        if(!user.msgs) {
          user.msgs = []
          user.liveData.loaded = false
        } else {
          user.liveData.loaded = true
        }
        this.fillUsersWithTags([user])
        this.users.push(user)
      })
      this.socket.on('disconnect', () => {
        this.notify('error', 'view.livechat.error.disconnection')
      })
    },

    async onConnect() {
      let adminToSend = this.$store.state.admin
      this.socket.emit('connected', adminToSend)
      this.notify('success', 'view.livechat.success.connection')
    },

    onReceiveUsers(users) {
      for (let i = 0; i < users.length; i++) {
        let exist = false
        for (let j = 0; j < this.users.length; j++) {
          if (this.users[j].userData.outside_id === users[i].userData.outside_id) {
            exist = true
          }
        }
        if (exist) {
          users.splice(i, 1)
          i--
          continue
        }
        for (let j = 0; j < this.usersGroups.length; j++) {
          if (this.usersGroups[j].filter(users[i])) this.usersGroups[j].offset++
        }
        users[i].liveData = {
          new: false,
          tags: [],
          loadFailed: false
        }
        if(!users[i].msgs) {
          users[i].msgs = []
          users[i].liveData.loaded = false
        } else {
          users[i].liveData.loaded = true
        }
      }
      if(this.users.length === 0) this.users = users
      else this.users = this.users.concat(users)
    },

    fillUsersWithTags (users) {
      for(let i = 0; i<this.tagsConnections.length; i++) {
        const actConnection = this.tagsConnections[i]

        for(let j = 0; j<this.users.length; j++) {
          const actUser = this.users[j]
          if(actUser.userData.id === actConnection.users_id) {
            for(let k = 0; k<this.tags.length; k++) {
              const actTag = this.tags[k]
              if(actTag.id === actConnection.livechat_tags_id) {
                actUser.liveData.tags.push(actTag)
                actTag.users.push(actUser)
                break
              }
            }
          }
        }
      }

    },

    onReceiveMsg(userId, msg) {
      for (let i = 0; i < this.users.length; i++) {
        if (this.users[i].userData.outside_id === userId) {
          if (this.users[i] !== this.selectedUser) this.users[i].liveData.new = true
          if (this.users[i].liveData.loaded) {
            this.users[i].msgs.push(msg)
            if(msg.sent_at) this.users[i].userData.last_msg_date = msg.sent_at
          }
          break
        }
      }
    },

    onReceiveUserResolved(userId) {
      for (let i = 0; i < this.users.length; i++) {
        if (this.users[i].userData.outside_id === userId) {

          const spliced = this.users.splice(i, 1)[0]
          this.adjustOffsetBefore(spliced)
          spliced.userData.moderator_chat = false
          spliced.userData.moderator_chat_order = null
          this.adjustOffsetAfter(spliced)
          this.users.push(spliced)
        }
      }
    },

    adjustOffsetBefore(user) {
      for (let j = 0; j < this.usersGroups.length; j++) {
        if (this.usersGroups[j].filter(user)) {
          this.usersGroups[j].offset--
        }
      }
    },

    adjustOffsetAfter(user) {
      for (let j = 0; j < this.usersGroups.length; j++) {
        if (this.usersGroups[j].filter(user)) {
          this.usersGroups[j].offset++
        }
      }
    },

    async fetchPersonas() {
      try {
        let res = await axios.get('/api/personas/list')
        this.personas = res.data.personas
      } catch (e) {
        console.error(e)
      }
    },

    async fetchTags () {
      try {
        let res = await axios.get('/api/livechat/tags')
        const tags = res.data.tags
        for(let i = 0; i<tags.length; i++) {
          tags[i].filter = false
          tags[i].editable = false
          tags[i].users = []
        }
        this.tags = tags
      } catch (e) {
        console.error(e)
      }
    },

    async fetchTagsConnections () {
      try {
        const res = await axios.get('/api/livechat/tags/connections')
        
        this.tagsConnections = res.data.connections
      } catch (e) {
        console.error(e)
      }
    },

    async loadUsersHistories (users) {
      try {
        const res = await axios.post('/api/livechat/history', {
          users: users.map((item) => {
            return {
              userData: item.userData
            }
          })
        })

        const histories = res.data.histories
        for(let i = 0; i<histories.length; i++) {
          if(!histories[i]) {
            users[i].liveData.loadFailed = true
            this.notify('error', 'view.livechat.error.userLoad')
            continue
          }
          users[i].msgs = histories[i]
          users[i].liveData.loaded = true
        }

      } catch (e) {
        console.error(e)
      }
    },

    //// ======================================================
    //// misc

    async userSelected(user) {
      this.selectedUser = user
      this.selectedUser.liveData.new = false
      this.selectedUser.liveData.loadFailed = false
      if(!this.selectedUser.liveData.loaded) {
        await this.loadUsersHistories([this.selectedUser])
      }
    },

    startSelected() {
      const toDisplay = this.getUsersToDisplay()
      if (toDisplay.length > 0)
        this.selectedUser = toDisplay[0]
    },

    getUsersToDisplay() {
      return this.users.filter(x => {
        if (x.msgs !== null) return true
      })
    }
  }
}
</script>

<style lang="scss">
.lc-main-window {
  display: flex;
  align-items: stretch;
  &__chat-window {
    flex-grow: 1;
    border-radius: 4px;
    padding: 10px;
    background: $bgLightGrey;
    margin-right: 8px;
  }

  &__no-selected {
    flex-grow: 1;
    border-radius: 4px;
    padding: 10px;
    background: $bgLightGrey;
    margin-right: 8px;

    display: flex;
    align-items: center;
    justify-content: center;

    font-size: 1.5em;
    font-weight: bold;
  }

  &__loading {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.5em;
    font-weight: bold;
  }

  &__loading-cont {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &__loading-spinner {
    margin-top: 6px;
    font-size: 1.1em;
  }

  &__users-cont {
    position: relative;
    border-radius: 4px;
  }

  &__users-list {
    width: 340px;
    //padding: 6px;
    height: calc(100%);
  }

  &__spinner-anim {
    animation-name: spinner-rotate;
    animation-duration: 1s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }

  @keyframes spinner-rotate {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
}
</style>
